﻿import idiMessageBox from './messageBoxService/messageBox.module';
import locationIsoModal from './locationIsoModalService/locationIsoModal.module';

import * as ViewLockService from './viewLockService/viewLock.service';
import * as ScreenLockService from './screenLockService/screenLock.service';
import * as MessageBarService from './messageBarService/messageBar.service';
import * as LogService from './logservice/log.service';
import * as SessionService from './sessionService/session.service';
import {AuthorizationProvider} from './authorizationService/authorization.provider';
import * as ScoreBoardAmountService from './scoreBoardAmountService/scoreBoardAmount.service';
import * as ScoreBoardTextService from './scoreBoardTextService/scoreBoardText.service';
import * as HttpPendingRequest from './httpPendingRequestService/httpPendingRequest.service';
import {ErrorRedirectService} from './errorRedirectService/errorRedirect.service';
import * as SubmissionStateService from './submissionStateService/submissionState.service';
import {CookieService} from './cookieService/cookie.service';
import {DependentDataService} from './dependentDataService/dependentData.service';
import {UserAccountStateService} from './userAccountStateService/userAccountState.service';
import {FormValidationService} from './formValidationService/formValidation.service';
import { UserService } from './userService/user.service';



export default angular.module('idi.marketplace.services', [idiMessageBox, locationIsoModal])
    .service('viewLockService', ViewLockService.ViewLockService)
    .service('screenLockService', ScreenLockService.ScreenLockService)
    .service('messageBarService', MessageBarService.MessageBarService)
    .service('scoreBoardAmountService', ScoreBoardAmountService.ScoreBoardAmountService)
    .service('scoreBoardTextService', ScoreBoardTextService.ScoreBoardTextService)
    .service('logService', LogService.LogService)
    .service('sessionService', SessionService.Session)
    .service('httpPendingRequestService', HttpPendingRequest.HttpPendingRequestService)
    .service('errorRedirectService', ErrorRedirectService)
    .service('cookieService', CookieService)
    .service('dependentDataService', DependentDataService)
    .service('userAccountStateService', UserAccountStateService)
    .service('formValidationService', FormValidationService)
    .service('submissionStateService', SubmissionStateService.SubmissionStateService)
    .service('userService', UserService)
    .provider('intrepidAuthorizationService', AuthorizationProvider)
    .name;